import { memo } from 'react';
import { MainLogo } from 'components/Logo/MainLogo';
import { RootMenuContent } from './styled';
import RootMenu from './RootMenu/RootMenu';
import { ROOT_MENU } from 'settings/main-menu/root-menu';
import { DrawerSidebar } from './DrawerSidebar/DrawerSidebar';
import MenuSection from './MenuSection/MenuSection';
import { ROOT_MENU_ENUM } from 'settings/main-menu/menus.enum';
import { disableConciliation } from 'utils/flags-utils';

const MainSidebar = () => {
  const rootMenu = disableConciliation
    ? ROOT_MENU.filter((item) => item.menuType !== ROOT_MENU_ENUM.CONCILIATION)
    : ROOT_MENU;

  return (
    <DrawerSidebar
      rootMenu={
        <RootMenuContent>
          <MainLogo />
          <RootMenu rootMenu={rootMenu} />
        </RootMenuContent>
      }
    >
      <MenuSection />
    </DrawerSidebar>
  );
};

export default memo(MainSidebar);
